export default "__VITE_ASSET__BQpKjZqm__"